import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import WeexModal from "../comps/weexModais/WeexModal";
import TermosCondicoesService from "../services/TermosCondicoesService";
import UsuarioService from '../services/UsuarioService';
import {useStore} from 'react-redux';
import CampanhaService from '../services/CampanhaService'

function AcceptLegalTerm(props) {
	const campanhaService = new CampanhaService()
	const eventoCorrente = campanhaService.campanhaCorrente()
	const requiredInterests = eventoCorrente.requiredInterests;
	const i18n = useStore().getState().i18n
	const termosCondicoesService = new TermosCondicoesService();
	const usuarioService = new UsuarioService()
	const [erro, setErro] = useState({
		isWrong: false,
		titulo: "",
		mensagem: "",
	});
	const history = useHistory();


	const handleLegalTerm = () => {
		
		termosCondicoesService.aceiteTermoObrigatorio(
			(erro, sucesso) => {
				if (erro) {
					setErro({
						isWrong: true,
						titulo: i18n.message("geral.erro.network.titulo", "Há algo errado"),
						mensagem:
							i18n.message("geral.erro.network.mensagem", "Houve um problema no processamento do seu pedido, por favor verifique sua internet ou contate o suporte"),
					});
					return;
				}
				if (sucesso) {
					let usuario = usuarioService.usuarioCorrente();
					usuario.legalTerm = sucesso.acceptLegalTerm
					usuarioService.setUsuarioCorrente(usuario)
                    props.callbackLogin(usuario)
					campanhaService.contadorCampanha((erro, sucesso)=>{
						if(erro){
							setErro({
								isWrong: true,
								titulo: i18n.message("atividades.erro.dias.habilitados", "Erro obter lista de dias habilitados")
							});
							return;
						}
						if(sucesso){
							if(sucesso !== null){
								if(sucesso.length > 0 ){
									history.push('/atividades')
								} else {
									history.push("/home")
								}
							}
						}
					})
				}
			}
		);
	};

	const callbackModal = () => {
		if (erro.isWrong === true) {
			setErro({ isWrong: false });
		}
	};

	return (
		<>
			{erro.isWrong === true ? (
				<WeexModal
					callback={callbackModal}
					visivel={erro !== null}
					titulo={erro.titulo}
					conteudo={erro.mensagem}
				/>
			) : null}

			<div className="weex_user_container" style={{ marginTop: "130px" }}>
				<div style={{ width: "100%" }}>
					<div className="field legalTerm-field">
						<span className="label legalTerm-Title">{i18n.message("registro.legal.termos", "Termos e Condições")}</span>
						<div className="legalTerm-msg">
							<span>
								{i18n.message("aceiteTermos.condicao", "Para acessar a campanha, é necessário ler e aceitar os")} {" "}
								<a
									href="https://weex.digital/politica-de-privacidade-e-uso/"
									target="_blank"
									rel="noopener noreferrer"
								>
									{i18n.message("registro.legal.termos", "Termos e Condições")}
								</a>{" "}
								{i18n.message("registro.legal.daweex", "da Weex")}
								
							</span>
						</div>
					</div>

					<div className="legalTerm-btn">
						<button onClick={handleLegalTerm} className="weex-button">
							{i18n.message("aceiteTermos.acao", "Aceitar termos e condições")}
						</button>
					</div>
				</div>
			</div>
		</>
	);
}

export default AcceptLegalTerm;
